import { LeftNavigation } from './LeftNavigation';

export default LeftNavigation;
